import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from "react-redux";
import { Formik } from 'formik';

import { Grid } from '@material-ui/core';
import _ from 'lodash'
import moment from 'moment';

import { calculateLoanProceeds, downloadLoanProceeds } from "store/state/calculators/testHarness";
import { getLoanProceedAssumptions } from 'store/state/loan/loan';

import { PrimaryButton, ButtonSizeOptions, SecondaryButton } from '@loanbossinc/component-library';

import { PARALLEL_SHOCK, MARKET_EXPECTATIONS_SHOCK } from "../../Constants/Constants";
import { getConfigItemByParentId } from 'store/state/configItems';
import { INTEREST_RATE_TYPE, FIXED_INDICES } from "constants/configItemParents";
import { floatingIndexList } from "constants/floatingIndexes";
import { setConfigItemListState } from "components/Global/Fields/util";

import FormSectionTitle from './FormSectionTitle';
import AssetAssumptionsSection from "./AssetAssumptionsSection";
import LoanAssumptionsSection from "./LoanAssumptionsSection";
import ConstraintsSection from "./ConstraintsSection";
import RateEnvironmentSection from "./RateEnvironmentSection";
import { TopParentGrid, ParentGrid, ButtonBar, StyledDatePicker, LastGrid } from '../styles';

class LoanProceedsForm extends Component {
  state = {
    interestRateTypes: [],
    floatingIndices: [],
    fixedIndices: [],
  }

  componentDidMount() {
    this.props.getLoanProceedAssumptions();
    this.props.getConfigItemByParentId({ id: INTEREST_RATE_TYPE });
    this.props.getConfigItemByParentId({ id: FIXED_INDICES });
    this.setState({ floatingIndices: floatingIndexList.filter(fil => fil.name !== "None") });
  }

  componentDidUpdate() {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(INTEREST_RATE_TYPE, "interestRateTypes", this);
      setConfigItemListState(FIXED_INDICES, "fixedIndices", this);
    }
  }

  createLoanProceedsRequestParameters = (values) => {
    const {
      UwRate,
      amortizationTerm,
      debtYield,
      dscr,
      futureCapRate,
      interestRateType,
      rateIndex,
      loanTerm,
      loanType,
      maxLTV,
      projectedNOI,
      shockType,
      shockValue,
      spread,
    } = values;


    const loanProceedsRequestParameters = {};
    loanProceedsRequestParameters.subKey = "calculator";
    loanProceedsRequestParameters.calculationDate = moment(values.calculationDate).format("YYYY-MM-DD");

    loanProceedsRequestParameters.shockType = !shockType ? MARKET_EXPECTATIONS_SHOCK : shockType;


    loanProceedsRequestParameters.shockValue = parseFloat(shockValue);

    if (shockType === PARALLEL_SHOCK && values.shockValue && values.shockValue !== 0) {
      const parallelValue = parseFloat(shockValue) * 0.0001;
      loanProceedsRequestParameters.shockValue = parallelValue;
    }

    if (shockType === MARKET_EXPECTATIONS_SHOCK)
      delete loanProceedsRequestParameters.shockValue;

    if (futureCapRate) loanProceedsRequestParameters.futureCapRate = this.transformRate(futureCapRate);
    loanProceedsRequestParameters.projectedNOI = projectedNOI;

    loanProceedsRequestParameters.loanType = loanType;
    loanProceedsRequestParameters.loanTerm = loanTerm;
    loanProceedsRequestParameters.amortizationTerm = amortizationTerm;
    if (spread) loanProceedsRequestParameters.spread = this.transformRate(spread);
    loanProceedsRequestParameters.interestRateType = interestRateType;
    loanProceedsRequestParameters.rateIndex = rateIndex;
    if (UwRate) loanProceedsRequestParameters.UwRate = this.transformRate(UwRate);

    if (debtYield) loanProceedsRequestParameters.debtYield = this.transformRate(debtYield);
    loanProceedsRequestParameters.dscr = dscr;
    if (maxLTV) loanProceedsRequestParameters.maxLTV = this.transformRate(maxLTV);

    return loanProceedsRequestParameters;
  }

  transformRate = (val) => {
    return +val / 100;
  }
  handleDownload = (values) => {

    let request = this.createLoanProceedsRequestParameters(values);
    request.callback = () => {
      this.props.downloadLoanProceeds({ assumptions: values, loanProceeds: this.props.loanProceeds });
    }

    this.props.calculateLoanProceeds(request);
  }

  setLoanProceedAssumptions = (selectedItem, formik) => {
    if (this.props.loanProceedAssumptions || this.props.loanProceedAssumptions.length > 0) {
      const foundloanProceedAssumptions = _.find(this.props.loanProceedAssumptions, { "loanType": selectedItem.value, },);

      formik.values.loanType = foundloanProceedAssumptions.loanType;
      formik.values.loanTerm = foundloanProceedAssumptions.term;
      formik.values.amortizationTerm = foundloanProceedAssumptions.amortization;
      formik.values.spread = foundloanProceedAssumptions.loanSpread ? foundloanProceedAssumptions.loanSpread : "";
      formik.values.interestRateType = foundloanProceedAssumptions.rateTypeId;
      formik.values.rateIndex = foundloanProceedAssumptions.indexId;
      formik.values.UwRate = foundloanProceedAssumptions.UwRate ? foundloanProceedAssumptions.UwRate : "";

      formik.values.debtYield = foundloanProceedAssumptions.minDebtYield ? foundloanProceedAssumptions.minDebtYield : "";
      formik.values.dscr = foundloanProceedAssumptions.minDSCR ? foundloanProceedAssumptions.minDSCR : "";
      formik.values.maxLTV = foundloanProceedAssumptions.maxLTV ? foundloanProceedAssumptions.maxLTV : "";
    }
  }

  render() {

    let initialValues = {
      calculationDate: moment(),

      shockType: MARKET_EXPECTATIONS_SHOCK,
      shockValue: "",

      futureCapRate: "",
      projectedNOI: "",

      loanType: "",
      loanTerm: "",
      amortizationTerm: "",
      spread: "",
      interestRateType: "",
      rateIndex: "",
      UwRate: "",

      debtYield: "",
      dscr: "",
      maxLTV: ""
    }

    return (
      <Formik
        initialValues={initialValues}
        enableReinitialize={false}
        validate={values => { let errors = {}; return errors; }}
        onSubmit={(values, { setSubmitting }) => {
          let request = this.createLoanProceedsRequestParameters(values);
          this.props.calculateLoanProceeds(request);
          setSubmitting(false);
        }}
        render={({ values, errors, status, touched, isSubmitting, handleChange, handleBlur, handleSubmit }) => (
          <Fragment>

            <TopParentGrid container alignItems="center" spacing={8} >
              <Grid item xs={12}><FormSectionTitle title="LOAN PROCEEDS CALCULATOR" /></Grid>
              <Grid item xs={3}>
                <StyledDatePicker label="Calculation Date" fieldName="calculationDate" />
              </Grid>
            </TopParentGrid>
            <ParentGrid container alignItems="center" justify="flex-start" spacing={8}><AssetAssumptionsSection /></ParentGrid>
            <ParentGrid container alignItems="center" spacing={8}><LoanAssumptionsSection setLoanProceedAssumptions={this.setLoanProceedAssumptions}
              interestRateTypes={this.state.interestRateTypes}
              floatingIndices={this.state.floatingIndices}
              fixedIndices={this.state.fixedIndices}

            /></ParentGrid>
            <ParentGrid container alignItems="center" spacing={8}><ConstraintsSection /></ParentGrid>
            <ParentGrid container alignItems="center" spacing={8}><RateEnvironmentSection /></ParentGrid>
            <LastGrid container alignItems="center" spacing={8}></LastGrid>
            <ParentGrid container alignItems="center" spacing={8}>
              <ButtonBar item xs={12}>
                <PrimaryButton
                  style={{ marginRight: 24 }}
                  label="Calculate"
                  onClick={handleSubmit}
                  size={ButtonSizeOptions.smFluid}
                />
                <SecondaryButton
                  label="Download"
                  onClick={() => this.handleDownload(values)}
                  size={ButtonSizeOptions.smFluid}
                />
              </ButtonBar>
            </ParentGrid>
          </Fragment>
        )} />
    );
  }
}


function mapStateToProps({ testHarness, loan, configItems }) {
  return {
    loanProceeds: testHarness.loanProceeds && testHarness.loanProceeds.calculator ? testHarness.loanProceeds.calculator : null,
    loanProceedAssumptions: loan.loanProceedAssumptions,
    configItems
  }
}

export default compose(
  connect(
    mapStateToProps,
    {
      calculateLoanProceeds,
      downloadLoanProceeds,
      getLoanProceedAssumptions,
      getConfigItemByParentId,
    }
  ))(LoanProceedsForm);
